<ng-container [ngSwitch]="mode">

  <a [routerLink]="disableLink ? undefined : [job._IsSponsored?'/r/job':'/job', job.Id]"
    [queryParams]="{sp: (job._IsSponsored?1:undefined), ad: advertiseId}"
    [attr.disabled]="!hideDateAndStatus && job.IsExpired?'disabled':undefined"
    [target]="sharedService.isPwa ? undefined : '_blank'"
    [ga-event]="job._IsSponsored?'job-list-click|seeker|'+job?.SourceName:undefined">
    <h3 *ngSwitchCase="'simple'" class="h6 f-blue" [innerHTML]="title"></h3>

    <div *ngSwitchDefault class="mb-2 py-1 px-2 px-md-0 white-bg kp-highlight overflow-hidden">
      <div class="d-flex align-items-center lh-1">
        <div class="d-flex align-items-center fs-sm  no-wrap-ellipsis" *ngIf="!job.IsKarpashaJob">
          <img class="icon-sm ml-1" *ngIf="job.SourceDomain" [alt]="job.SourceDomain"
            [src]="'https://www.google.com/s2/favicons?sz=48&domain='+job.SourceDomain" />
          <i *ngIf="!job.SourceDomain" class="fa ml-1 fs-lg f-gray" [class.fa-telegram]="job.SourceType==2"
            [class.fa-instagram]="job.SourceType==3" [class.fa-globe]="job.SourceType!=2 && job.SourceType!=3"></i>
          <span class="no-wrap-ellipsis">در {{job.SourceTypeTitle}} {{job.IsIndexed ? job.SourceName :
            ''}}</span>&nbsp;
          <span class="f-gray no-wrap-ellipsis" *ngIf="!hideDateAndStatus">
            (<ng-container *ngIf="job.StartTime">{{job.StartTime|pdate:true}}</ng-container>
            <ng-container *ngIf="!job.StartTime">ثبت: {{job.RegisterTime|pdate:true}}</ng-container>)
          </span>
        </div>
        <div class="mr-auto">
          <span class="fa-bookmark fs-lg ml-md-2 pl-md-1 pr-3 pr-md-0 pt-1 order-md-first pointer" *ngIf="showFavorite"
            [class.far]="!favorite" [class.fa]="favorite" [class.f-blue]="favorite" [class.f-gray]="!favorite"
            (click)="setFavorite(job,$event)" click-stop-propagation style="line-height: initial;"></span>

        </div>
      </div>
      <div class="d-flex pt-1">
        <div class="flex-fill overflow-hidden" style="max-height: 55px">
          <div class="d-inline-flex wrap" [class.f-default-link]="hideDateAndStatus || !job.IsExpired"
            [class.f-gray]="!hideDateAndStatus && job.IsExpired">
            <h2 class="{{Utility.mobile ? 'h4' : 'h5'}} mb-0" [innerHTML]="title"></h2>
            <div class="f-red mr-1 nowrap fw-bold" *ngIf="!hideDateAndStatus && job.IsExpired">(منقضی شده)</div>
          </div>
        </div>
      </div>
      <div class="lh-sm fs-sm mb-1 d-flex justify-content-between">
        <div class="d-flex flex-wrap">
          <div class="ml-1" *ngIf="job.Company" [innerHTML]="job.HighlightedCompany"></div>
          <div>&nbsp;در {{Utility.wordSubstring(job.LocationString, 50)}}</div>
        </div>
      </div>
      <div class="fs-sm f-gray lh-sm my-1 text-justify" [attr.dir]="job.IsLtr ? 'ltr' : undefined">
        <div class="mb-1" *ngIf="job.HighlightedBrief"  [innerHTML]="job.HighlightedBrief"></div>
        <div class="d-flex flex-wrap align-items-center">
          <div *ngFor="let field of fields" class="badge p-1 x-light-gray-bg fs-sm f-black fw-normal ml-1 mb-1">
            {{field.value}}</div>
        </div>
      </div>
      <div class="d-flex flex-wrap align-items-center lh-sm fs-sm">
        <div class="d-flex flex-wrap align-items-center">
          <span class="badge badge-pill yellow-bg fw-normal py-1 ml-1" *ngIf="isNew">جدید</span>
          <span *ngIf="job.IsPaid" class="badge badge-pill border fs-sm fw-normal  p-0 ml-1">
            <img class="icon-sm" src="/assets/images/icons/vanguard.svg" alt="آگهی پیشتاز" />
            <span class="p-1 pl-2">آگهی پیشتاز</span>
          </span>
          <span *ngIf="job._IsSponsored" class="badge badge-pill border fs-sm fw-normal  p-0 ml-1">
            <img class="icon-sm" src="/assets/images/icons/vanguard.svg" alt="آگهی پیشران"
              style="filter: grayscale(1);" />
            <span class="p-1 pl-2">آگهی پیشران</span>
          </span>
          <span *ngIf="job.IsAppliable" class="badge badge-pill border fs-sm fw-normal  p-0 ml-1">
            <span class="icon-easy-apply icon-sm"></span>
            <span class="p-1 pl-2">استخدام آسان</span>
          </span>

        </div>
      </div>
      <ng-content select="[footer]"></ng-content>
    </div>
  </a>

</ng-container>